import slideTiles from './js/old/slideTiles';
import './scss/old-acf-blocks/slidetiles.scss';

slideTiles();
